import { createSlice } from "@reduxjs/toolkit";

export interface bartenders {
    bartenderList: [];

}

const initialState: bartenders = {
    bartenderList: [],
};


const bartenderSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        bartenderListSave: (state, action) => {
            state.bartenderList = action.payload;
        },
        // updateBartender: (state, action) => {
        //     const newdata = action.payload;
        //     const newlist = state.bartenderList.map((item) => {
        //         if(item.od)
        //         return item
        //     })
        //     state.bartenderList = newdata
        // },
    },

});

export const { bartenderListSave } = bartenderSlice.actions;
export default bartenderSlice.reducer;
